export default "__VITE_ASSET__Crqb5l$H__"